var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import { Para } from "@irati/ui/src/Labels";
import { connect } from "@irati/store";
import Loading from "@irati/ui/src/Loading";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import scheduledTransferActions from "@irati/wallet/store/actions/ScheduledTransfer";
import { ScheduledTransferStatus } from "@irati/types";
import NoData, { NoDataCTA } from "../NoData";
import DateHeader from "../DateHeader";
import { StyledHr, StyledScheduledTransfer, ShowMoreButton, StyledTooltip } from "./styled";
var PAGINATION_COUNT = 10;
var PENDING_TRANSACTIONS = [
    ScheduledTransferStatus.NotActivated,
    ScheduledTransferStatus.Pending,
    ScheduledTransferStatus.Failing,
    ScheduledTransferStatus.Failed
];
var CANCELLED_TRANSACTIONS = [ScheduledTransferStatus.Cancelled];
var ScheduledTransfers = /** @class */ (function (_super) {
    __extends(ScheduledTransfers, _super);
    function ScheduledTransfers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null,
            canLoadMore: true,
            cursor: null
        };
        _this.getMoreScheduledTransfers = function (existingScheduledTransfers, cursor) {
            var _a = _this.props.wallet, ownerUuid = _a.ownerUuid, uuid = _a.uuid;
            var scheduledTransferStatusParam = _this.props.isCancelledTransfers ? CANCELLED_TRANSACTIONS : PENDING_TRANSACTIONS;
            var list = _this.props
                .listScheduledTransfers(existingScheduledTransfers, ownerUuid, uuid, scheduledTransferStatusParam, cursor, PAGINATION_COUNT)
                .then(function (_a) {
                var newCursor = _a.newCursor;
                _this.setState({
                    canLoadMore: true,
                    cursor: newCursor
                });
            });
            _this.setState({
                load: list,
                canLoadMore: false
            });
        };
        _this.handleShowMoreClick = function () {
            var cursor = _this.state.cursor;
            if (cursor) {
                var results = _this.props.walletScheduledTransfer.results;
                _this.getMoreScheduledTransfers(results, cursor);
            }
        };
        return _this;
    }
    ScheduledTransfers.prototype.componentDidMount = function () {
        if (this.props.wallet.uuid) {
            this.getMoreScheduledTransfers([], null);
        }
    };
    ScheduledTransfers.prototype.componentWillUnmount = function () {
        this.props.clearScheduledTransfers();
    };
    ScheduledTransfers.prototype.componentDidUpdate = function () {
        if (this.props.wallet.uuid && !this.state.load) {
            this.getMoreScheduledTransfers([], null);
        }
    };
    ScheduledTransfers.prototype.render = function () {
        var _a = this.props, className = _a.className, walletScheduledTransfer = _a.walletScheduledTransfer, formatMessage = _a.formatMessage, isMobile = _a.isMobile, isCancelledTransfers = _a.isCancelledTransfers;
        var results = walletScheduledTransfer.results;
        var _b = this.state, cursor = _b.cursor, load = _b.load, canLoadMore = _b.canLoadMore;
        if (!results) {
            return React.createElement(Loading, { load: load });
        }
        var hasScheduledTransfers = results.length > 0;
        var idNamespace = id("scheduled-transfers", this.props);
        return (React.createElement("div", { className: className, id: idNamespace },
            hasScheduledTransfers && (React.createElement(Fragment, null,
                React.createElement(Para, { id: id("warning", idNamespace) },
                    isCancelledTransfers && (React.createElement(React.Fragment, null,
                        React.createElement(FormattedMessage, { id: "wallet.cancelledTransfers.tooltip.title" }),
                        React.createElement(StyledTooltip, { placement: "bottom" },
                            React.createElement(FormattedMessage, { id: "wallet.cancelledTransfers.tooltip.body" })))),
                    !isCancelledTransfers && React.createElement(FormattedMessage, { id: "wallet.scheduledTransfers.clearanceWarning" })),
                results.map(function (_a) {
                    var date = _a.date, data = _a.data;
                    var key = date.format("YYYY-MM-DD");
                    return (React.createElement(Fragment, { key: key },
                        React.createElement(StyledHr, null),
                        React.createElement(DateHeader, { id: id("date-header_" + key, idNamespace), date: date }),
                        data.map(function (scheduledTransfer) { return (React.createElement(StyledScheduledTransfer, { id: id("scheduled-transfer_" + scheduledTransfer.uuid, idNamespace), scheduledTransfer: scheduledTransfer, key: scheduledTransfer.uuid })); })));
                }),
                React.createElement(Loading, { load: load }),
                canLoadMore && cursor && (React.createElement(ShowMoreButton, { id: idNamespace, onClick: this.handleShowMoreClick },
                    React.createElement(FormattedMessage, { id: "wallet.scheduledTransfers.showMoreButton.text", values: { count: PAGINATION_COUNT } }))))),
            !hasScheduledTransfers && (React.createElement(NoData, { useCardStyle: isMobile, id: idNamespace, text: formatMessage({
                    id: isCancelledTransfers ? "wallet.noCancelledTransfers.text" : "wallet.noScheduledTransfers.text"
                }) },
                React.createElement(NoDataCTA, null)))));
    };
    ScheduledTransfers.defaultProps = {
        className: null
    };
    return ScheduledTransfers;
}(Component));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet, walletScheduledTransfer = _a.walletScheduledTransfer, mq = _a.mq;
    return {
        wallet: wallet,
        walletScheduledTransfer: walletScheduledTransfer,
        isMobile: mq.lessThan.large
    };
};
var actions = function (dispatch) {
    return {
        listScheduledTransfers: function (existingScheduledTransfers, walletOwnerId, walletId, scheduledTransferStatusParam, cursor, limit) {
            return dispatch(scheduledTransferActions.list(existingScheduledTransfers, walletOwnerId, walletId, scheduledTransferStatusParam, cursor, limit));
        },
        clearScheduledTransfers: function () { return dispatch(scheduledTransferActions.clear()); }
    };
};
export default injectIntl(connect(mapStateToProps, actions)(ScheduledTransfers));
